export const occurrences = [
  'daily',
  'weekly',
  'monthly',
  'yearly'
]